import api from './api';

/**
 * Serviço para buscar dados de relatórios
 */
const reportsService = {
  /**
   * Busca dados consolidados para gráficos e tabelas resumo
   * @param {string} startDate - Data inicial (ISO 8601)
   * @param {string} endDate - Data final (ISO 8601)
   * @returns {Promise<Object>} Dados consolidados de relatório
   */
  async getSummary(startDate, endDate) {
    const response = await api.get('/reports/summary', {
      params: { startDate, endDate }
    });
    return response.data;
  },

  /**
   * Busca agendamentos do período com paginação e ordenação
   * @param {Object} params
   * @param {string} params.startDate
   * @param {string} params.endDate
   * @param {number} params.page
   * @param {number} params.pageSize
   * @param {string} params.sortBy
   * @param {string} params.sortDirection
   * @returns {Promise<Object>} Página de agendamentos
   */
  async getAppointments({ startDate, endDate, page = 1, pageSize = 20, sortBy = 'startTime', sortDirection = 'desc' }) {
    const response = await api.get('/reports/appointments', {
      params: { startDate, endDate, page, pageSize, sortBy, sortDirection }
    });
    return response.data;
  }
};

export default reportsService;
